function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import STRtree from '../index/strtree/STRtree';
import NodedSegmentString from './NodedSegmentString';
import MonotoneChainOverlapAction from '../index/chain/MonotoneChainOverlapAction';
import MonotoneChainBuilder from '../index/chain/MonotoneChainBuilder';
import ArrayList from '../../../../java/util/ArrayList';
import SinglePassNoder from './SinglePassNoder';
var MCIndexNoder = /*#__PURE__*/function (_SinglePassNoder) {
  function MCIndexNoder() {
    var _this;
    _classCallCheck(this, MCIndexNoder);
    _this = _callSuper(this, MCIndexNoder);
    MCIndexNoder.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(MCIndexNoder, _SinglePassNoder);
  return _createClass(MCIndexNoder, [{
    key: "getMonotoneChains",
    value: function getMonotoneChains() {
      return this._monoChains;
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      return NodedSegmentString.getNodedSubstrings(this._nodedSegStrings);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._index;
    }
  }, {
    key: "add",
    value: function add(segStr) {
      var segChains = MonotoneChainBuilder.getChains(segStr.getCoordinates(), segStr);
      for (var i = segChains.iterator(); i.hasNext();) {
        var mc = i.next();
        mc.setId(this._idCounter++);
        this._index.insert(mc.getEnvelope(), mc);
        this._monoChains.add(mc);
      }
    }
  }, {
    key: "computeNodes",
    value: function computeNodes(inputSegStrings) {
      this._nodedSegStrings = inputSegStrings;
      for (var i = inputSegStrings.iterator(); i.hasNext();) {
        this.add(i.next());
      }
      this.intersectChains();
    }
  }, {
    key: "intersectChains",
    value: function intersectChains() {
      var overlapAction = new SegmentOverlapAction(this._segInt);
      for (var i = this._monoChains.iterator(); i.hasNext();) {
        var queryChain = i.next();
        var overlapChains = this._index.query(queryChain.getEnvelope());
        for (var j = overlapChains.iterator(); j.hasNext();) {
          var testChain = j.next();
          if (testChain.getId() > queryChain.getId()) {
            queryChain.computeOverlaps(testChain, overlapAction);
            this._nOverlaps++;
          }
          if (this._segInt.isDone()) return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MCIndexNoder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(SinglePassNoder);
export { MCIndexNoder as default };
var SegmentOverlapAction = /*#__PURE__*/function (_MonotoneChainOverlap) {
  function SegmentOverlapAction() {
    var _this2;
    _classCallCheck(this, SegmentOverlapAction);
    _this2 = _callSuper(this, SegmentOverlapAction);
    SegmentOverlapAction.constructor_.apply(_this2, arguments);
    return _this2;
  }
  _inherits(SegmentOverlapAction, _MonotoneChainOverlap);
  return _createClass(SegmentOverlapAction, [{
    key: "overlap",
    value: function overlap() {
      if (arguments.length === 4) {
        var mc1 = arguments[0];
        var start1 = arguments[1];
        var mc2 = arguments[2];
        var start2 = arguments[3];
        var ss1 = mc1.getContext();
        var ss2 = mc2.getContext();
        this._si.processIntersections(ss1, start1, ss2, start2);
      } else return _superPropGet(SegmentOverlapAction, "overlap", this, 1).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentOverlapAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(MonotoneChainOverlapAction);
SegmentOverlapAction.constructor_ = function () {
  this._si = null;
  var si = arguments[0];
  this._si = si;
};
MCIndexNoder.SegmentOverlapAction = SegmentOverlapAction;
MCIndexNoder.constructor_ = function () {
  this._monoChains = new ArrayList();
  this._index = new STRtree();
  this._idCounter = 0;
  this._nodedSegStrings = null;
  this._nOverlaps = 0;
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var si = arguments[0];
    SinglePassNoder.constructor_.call(this, si);
  }
};